import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ThreeFacts from '../key-issues/components/three-facts'
import AudioSection from './audio-section'
import { Link } from 'react-router-dom'
import { saveNavTheme } from '../../reducers/nav'

const mapStateToProps = (state) => {
    return {
        navState: state.nav
    }
}

const StyleGuideIndex = ({ navState, dispatch }) => {
    useEffect(() => {
        if (navState.theme !== 'grey') {
            dispatch(saveNavTheme('grey'))
        }
    })
    const [openSections, setOpenSections] = useState([])
    const [openLabel, setOpenLabel] = useState({})

    const toggleLabel = (label) => {
        setOpenLabel((prevOpenLabels) => ({
            ...prevOpenLabels,
            [label]: !prevOpenLabels[label]
        }))
    }

    return (
        <div className="style-guide">
            {/* Fonts */}
            <div className="section-sample">
                <span className="header" onClick={() => setOpenSections(openSections.includes('FONTS') ? openSections.filter(section => section !== 'FONTS') : [...openSections, 'FONTS'])}>
                    Fonts
                </span>
                { openSections.includes('FONTS') &&
                    <div className="samples">
                        <h1>Header 1</h1>
                        <h2>Header 2</h2>
                        <h3>Header 3</h3>
                        <h4>Header 4</h4>
                        <h5>Header 5</h5>
                        <h6>Header 6</h6>
                        <span className="label-header">
                            Label Header
                        </span>
                    </div>
                }
            </div>
            {/* Colors */}
            <div className="section-sample">
                <span className="header" onClick={() => setOpenSections(openSections.includes('COLORS') ? openSections.filter(section => section !== 'COLORS') : [...openSections, 'COLORS'])}>
                    Colors
                </span>
                {openSections.includes('COLORS') &&
                    <div className="samples">
                        <div className="swatches">
                            <div className="swatch teal">Teal</div>
                            <div className="swatch blue">Blue</div>
                        </div>
                    </div>
                }
            </div>
            {/* Buttons */}
            <div className="section-sample">
                <span className="header" onClick={() => setOpenSections(openSections.includes('BUTTONS') ? openSections.filter(section => section !== 'BUTTONS') : [...openSections, 'BUTTONS'])}>
                    Buttons
                </span>
                {openSections.includes('BUTTONS') &&
                    <div className="samples">
                        <div className="buttons-container">
                            <div className="button-wrapper">
                                <span className="btn">Primary Button</span>
                                <div className="button-wrapper">
                                    <span className="btn medium">Medium Button</span>
                                </div>
                                <div className="button-wrapper">
                                    <span className="btn small">Small Button</span>
                                </div>
                            </div>
                        </div>
                        <div className="buttons-container">
                            <div className="button-wrapper">
                                <span className="btn icon"><FontAwesomeIcon icon="arrow-right" /></span>
                            </div>
                            <div className="button-wrapper">
                                <span className="btn icon small"><FontAwesomeIcon icon="arrow-left" /></span>
                            </div>
                            <div className="button-wrapper">
                                <span className="btn icon grey"><FontAwesomeIcon icon="arrow-up"/></span>
                            </div>
                            <div className="button-wrapper">
                                <span className="btn icon small grey"><FontAwesomeIcon icon="arrow-down"/></span>
                            </div>
                            <div className="button-wrapper">
                                <span className="btn icon-text"><FontAwesomeIcon icon="arrow-down"/>Next</span>
                            </div>
                        </div>
                    </div>
                }
            </div>
            {/* Buttons */}
            <div className="section-sample">
                <span className="header" onClick={() => setOpenSections(openSections.includes('THREE_FACTS') ? openSections.filter(section => section !== 'THREE_FACTS') : [...openSections, 'THREE_FACTS'])}>
                    Three Facts
                </span>
                {openSections.includes('THREE_FACTS') &&
                    <div className="samples">
                        <ThreeFacts />
                    </div>
                }
            </div>

            {/* Key Issues */}
            <div className="section-sample">
                <span className="header" onClick={() => setOpenSections(openSections.includes('KEY ISSUES') ? openSections.filter(section => section !== 'KEY ISSUES') : [...openSections, 'KEY ISSUES'])}>
                Key Issues
                </span>
                { openSections.includes('KEY ISSUES') &&
                    <div className="samples">
                        <div className="key-issue-chip-container">
                            <div className="key-issue-chip-wrapper teal" onClick={() => toggleLabel('Intergenerational Assets')}>
                                <div className="key-issue-chip" />
                                <div className={`label ${openLabel['Intergenerational Assets'] ? 'open' : ''}`} >
                                    {openLabel['Intergenerational Assets'] ? '' : 'Intergenerational Assets'}
                                    {openLabel['Intergenerational Assets'] &&
                                    <>
                                        <title>Intergenerational Assets</title>
                                        <p>Intergenerational assets are the resources that families pass down</p>
                                        <Link className="clickable">Explore</Link>
                                    </>
                                    }
                                </div>
                            </div>
                            <div className="key-issue-chip-wrapper orange">
                                <div className="key-issue-chip" />
                                <div className="label">Access to Care</div>
                            </div>
                            <div className="key-issue-chip-wrapper blue">
                                <div className="key-issue-chip" />
                                <div className="label">For-Profit Colleges</div>
                            </div>
                            <div className="key-issue-chip-wrapper yellow">
                                <div className="key-issue-chip" />
                                <div className="label">Racism as Chronic Stressor</div>
                            </div>
                            <div className="key-issue-chip-wrapper magenta">
                                <div className="key-issue-chip" />
                                <div className="label">Lending Discrimination</div>
                            </div>
                        </div>
                        <div className="key-issue-view">
                            <div className="content-bands">
                                <div className="content-band interconnected-issues">
                                    <div className="tiles-wrapper">
                                        <div className="key-issue-tile" style={{ backgroundImage: `url(https://picsum.photos/400/250?grayscale&random=2)` }}>
                                            <div className="key-issue-label wealth">
                                                <span>Access to Credit</span>
                                            </div>
                                        </div>
                                        <div className="key-issue-tile" style={{ backgroundImage: `url(https://picsum.photos/400/250?grayscale&random=3)` }}>
                                            <div className="key-issue-label criminal-justice">
                                                <span>Civil Asset Forfeiture</span>
                                            </div>
                                        </div>
                                        <div className="key-issue-tile" style={{ backgroundImage: `url(https://picsum.photos/400/250?grayscale&random=4)` }}>
                                            <div className="key-issue-label education">
                                                <span>Education Segregation</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>

            {/* Media Player */}
            <div className="section-sample">
                <span className="header" onClick={() => setOpenSections(openSections.includes('MEDIA_PLAYER') ? openSections.filter(section => section !== 'MEDIA_PLAYER') : [...openSections, 'MEDIA_PLAYER'])}>
                    Media Player
                </span>
                {openSections.includes('MEDIA_PLAYER') &&
                    <AudioSection />
                }
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(StyleGuideIndex)
